import React, { useState, useEffect } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
  Badge,
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
} from "react-bootstrap";
import classnames from "classnames";
import { ChevronDown, ChevronUp, Eye, FileText, Mail, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import rob from "../assests/images/robot.gif";
import { BsEye } from "react-icons/bs";
import { resumeUploadList, singleBatchData, interviewMail, getQuestionId, editQuestion, addQuestion, deleteQuestion, resumeSingleMail, resumeBulkMail, candidateEdit } from "../services/auth";
import { toastError, toastSuccess } from "../config/ToastModal";
import FeedBack from "./FeedBack";
import ResumeViewer from "./ResumeViewer";
import { FaEdit, FaEnvelope } from "react-icons/fa";

const InterviewScheduleScreen = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [dummyData, setDummyData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectYesorNo, setSelectYesOrNo] = useState("");
  const [visibleBatchId, setVisibleBatchId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showMailModal, setShowMailModal] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [showPDF, setShowPDF] = useState(false);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleShowModal = () => {
    setIsOpen(true);
  };

  const [skilldatas, setSkillDatas] = useState([]);
  const [skilldatasfilter, setSkillDatasFilter] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentshowsecond, setCurrentShowSecond] = useState(10);
  const [showModal1, setShowModal1] = useState(false);
  const [showQuesModal, setShowQuesModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [candidate, setCandidate] = useState(null);
  const [showModal2, setShowModal2] = useState(false);
  const [feedBack, setFeedBack] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState("");
  const [editId, setEditId] = useState("");
  const [newQuestion, setNewQuestion] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [questionData, setQuestionData] = useState({ questionsResponse: [] })
  const [expandedCards, setExpandedCards] = useState(new Set());
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [selectedForMail, setSelectedForMail] = useState([]);
  const [isSending, setIsSending] = useState(false);
  const [batchId, setBatchId] = useState("")
  const [responseData, setResponseData] = useState();
  const [showEditModal, setShowEditModal] = useState(false);
  const [expandedCard, setExpandedCard] = useState(null);
  const [toggleId, setToggleId] = useState("")
  const [editCandidate, setEditCandidate] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const handleEdit = (index, currentText) => {
    console.log(index, currentText, "Edit triggered");
    setEditingId(index);
    setEditText(currentText);
  };

  const handleSave = async (index) => {
    console.log(index, editText, "Save triggered");
    try {
      const payload = {
        position: index,
        question: editText,
        _id: questionData?._id
      }
      const response = await editQuestion(payload)
      getData(editId)
      toastSuccess(response?.data?.message)
      console.log(response, "oooooooo========")
    } catch (error) {
      toastError("error")
      console.log(error, "eeeeeeee========")
    }
    cancelEdit();
  };

  const handleSendMail = () => {
    if (!skilldatas?.claudeResponses) return;

    // Flatten claudeResponse and attach parent _id
    const allCandidates = skilldatas.claudeResponses.flatMap(item =>
      (item.claudeResponse || []).map(res => ({
        ...res,
        parentId: item._id,   // attach parent _id
        batchId: item.batchId // optional if you need batch info later
      }))
    );

    // Filter by selectedCandidates (which should hold parentIds)
    const selected = allCandidates.filter(res =>
      selectedCandidates.includes(res.parentId)
    );

    // Deduplicate by parentId
    const uniqueSelected = Array.from(
      new Map(selected.map(res => [res.parentId, res])).values()
    );

    console.log(uniqueSelected, "selected--");
    setSelectedForMail(uniqueSelected);
    setShowMailModal(true);
  };

  const handleDelete = async (index, listId) => {
    console.log(`Deleting question at index ${index} from list ${listId}`);

    const payload = {
      _id: listId,
      position: index,
    };

    try {
      const response = await deleteQuestion(payload);
      toastSuccess(response?.data?.message || "Question deleted successfully");
      getData(editId);

    } catch (error) {
      console.error("Delete question failed:", error);
      toastError(error?.response?.data?.message || "Failed to delete question.");
    }
    if (editingId === index) {
      cancelEdit();
    }
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditText("");
  };

  const handleAddQuestion = async () => {
    if (newQuestion.trim()) {
      const payload = {
        _id: editId?._id,
        question: newQuestion.trim()
      };

      try {
        const response = await addQuestion(payload);
        if (response.status == 200) {
          toastSuccess(response?.data?.message || "Question added successfully");
          getData(editId);
          setNewQuestion("");
          setShowAddForm(false);
        } else {
          toastError(response.message)
        }
      } catch (error) {
        toastError("Failed to add question");
        console.error("Add Question Error:", error);
      }
    }
  };

  const handleOpenQuesModal = (batch) => {
    console.log(batch?._id, "bbbb--------")
    setShowQuesModal(true)
    setEditId(batch)
    getData(batch)
  }

  const handleOpenListModal = async (batch) => {
    console.log(batch?._id, "bbbb--------")
    setBatchId(batch?._id)
    try {
      const response = await singleBatchData({ id: batch._id });
      console.log(response?.data?.result?.data[0], "response====")
      setSkillDatas(response?.data?.result?.data[0]); // Assuming correct structure
    } catch (error) {
      console.error("Error fetching batch data", error);
    }

    setSelectedBatch(batch);
    setShowListModal(true)
  }

  const getData = async (batch) => {
    // Add a safety check to prevent API calls with an undefined ID
    if (!batch?._id) {
      console.warn("getData called without a valid batch ID.");
      return;
    }

    try {
      const response = await getQuestionId(batch._id);
      const questionList = response?.data?.qustionList;

      if (questionList) {
        const cleanedQuestions = (questionList.questionsResponse || []).filter(Boolean);
        setQuestionData({
          ...questionList,
          questionsResponse: cleanedQuestions,
        });

      } else {
        // Handle the case where no question list is returned from the API
        setQuestionData({ questionsResponse: [] });
      }
    } catch (error) {
      console.error("Error fetching question data:", error);
      toastError("Could not load questions.");
      // It's good practice to reset the state on error
      setQuestionData({ questionsResponse: [] });
    }
  };

  const handleQuesCloseModal = () => {
    setShowQuesModal(false)
  }

  const handleOpenModals = (data) => {
    setCandidate(data);
    setShowModal1(true);
  };

  const handleCloseModals = () => {
    setShowModal1(false);
    setCandidate(null);
  };

  const handleListCloseModal = () => {
    setExpandedCard((prev) => (prev === toggleId ? null : toggleId));
    setShowListModal(false);
    setSelectedCandidates([])
  };

  const handleOpenModals1 = (data) => {
    setFeedBack(data);
    setShowModal2(true);
  };

  const handleCloseModals1 = () => {
    setShowModal2(false);
    setFeedBack(null);
  };

  const toggleCardExpansion = (id) => {
    setToggleId(id)
    setExpandedCard((prev) => (prev === id ? null : id));
    const newSet = new Set(expandedCards);
    newSet.has(id) ? newSet.delete(id) : newSet.add(id);
    setExpandedCards(newSet);
  };


  const handleSelectAllUserIds = () => {
    if (selectYesorNo) {
      if (!selectAll) {
        const allIds = skilldatasfilter?.map((item) => item?.id);
        setSelectedUserIds(allIds);
      } else {
        setSelectedUserIds([]);
      }
      setSelectAll(!selectAll);
    } else {
      toast.error("Please Select Filter Status");
    }
  };

  const handleSelectUserIds = async (paramsUserId) => {
    try {
      if (selectedUserIds?.includes(paramsUserId)) {
        setSelectedUserIds((pre) => pre.filter((id) => id !== paramsUserId));
      } else {
        setSelectedUserIds((pre) => [...pre, paramsUserId]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getMatchBadgeColor = (percentage) => {
    if (percentage == 100) return "success";
    if (percentage >= 67) return "warning";
    if (percentage >= 34) return "info";
    return "danger";
  };

  const getSkillBadgeColor = (count) => {
    if (count === 0) return "light";
    if (count <= 2) return "primary";
    if (count <= 5) return "info";
    return "success";
  };

  const extractFileName = (url) => {
    return url ? url.split("/").pop().split("-")[0] : "-";
  };

  const clockToggle = () => {
    setIsOpen(false);
  };

  const handleChangeYesorNo = async (e) => {
    try {
      const selectedValue = e.target.value;
      setSelectYesOrNo(selectedValue);
      const filteredData = skilldatas?.filter(
        (item) => item?.status === selectedValue
      );
      setSkillDatasFilter(filteredData);
      setSelectedUserIds([]);
    } catch (error) {
      console.error("Error in handleChangeYesorNo:", error);
    }
  };

  const handleNavigatePath = async (id) => {
    try {
      navigate(`/ai-complete-view-feedback/${id}`);
    } catch (error) { }
  };

  const handleScheduleInterview = async () => {
    try {
      if (true) {
        // toastAlert("success", "Interview scheduled successfully.", 4000);
        setTimeout(() => {
          clockToggle();
        }, 400);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangePageSize = async (pageNo) => {
    try {
      setCurrentPage(pageNo);
      if (pageNo === 1) {
        setCurrentShowSecond(10);
      } else {
        setCurrentShowSecond(pageNo * 10);
      }
    } catch (error) { }
  };

  const tabNames = [
    "Selected Resumes",
    "Finished Interview",
    "AI Interview Incomplete",
    "ShortListed Candidates",
  ];
  const [seledtId, setSelectedId] = useState({})
  const [isRefreshing, setIsRefreshing] = useState(false);

  // Updated handleOpenModal function
  const handleOpenModal = async (batch) => {
    console.log(batch, "bbbbbb")
    setSelectedId(batch)
    setIsRefreshing(true); // Start loading
    try {
      const response = await singleBatchData({ id: batch._id });
      setSkillDatas(response?.data?.result?.data[0]); // Assuming correct structure
    } catch (error) {
      console.error("Error fetching batch data", error);
    } finally {
      setIsRefreshing(false); // Stop loading
    }

    setSelectedBatch(batch);
    setShowModal(true);
  };

  // Updated handleRefresh function
  const handleRefresh = () => {
    handleOpenModal(seledtId);
  }
  const [batchIds, setBatchIds] = useState("")

  const [isSendings, setIsSendings] = useState(false);

  const handleMailSend = async () => {
    let foundBatchId = null;

    skilldatas?.claudeResponses?.forEach((item) => {
      if (item?.batchId) {
        foundBatchId = item.batchId;
      }
    });

    if (!foundBatchId) {
      console.error("Batch ID not found");
      toastError("Batch ID is missing!");
      return;
    }

    console.log("Sending mail for batch:", foundBatchId);

    setIsSendings(true); // 🔥 Start loading
    try {
      const response = await interviewMail({ batchId: foundBatchId });

      console.log("Response:", response);

      if (response?.data?.message) {
        setShowModal(false);
        toastSuccess(response?.data?.message);
      } else {
        toastError("No confirmation received.");
      }
    } catch (error) {
      console.error("Error sending interview mail:", error);
      toastError("Failed to send mail. Please try again.");
    } finally {
      setIsSendings(false); // 🔥 Stop loading after success/failure
    }
  };


  const handleSelection = (id, checked) => {
    setSelectedCandidates((prev) =>
      checked ? [...prev, id] : prev.filter((c) => c !== id)
    );
  };


  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedBatch(null);
  };

  const handleCloseListModal = () => {
    setSelectedCandidates([]);       // ✅ Clear checkboxes
    setSelectedForMail([]);         // ✅ Clear mail selections too
    setShowMailModal(false);
    setShowListModal(false);        // <-- Add this if missing
    setSelectedBatch(null);
  };

  const handleCloseMailModal = () => {
    setShowMailModal(false);
  };

  const selectedMailSend = async () => {
    setIsSending(true);

    try {
      if (selectedForMail.length > 1) {
        // Bulk mail
        const payload = selectedForMail.map((item) => ({
          candidateEmail: item.Email,
          candidateName: item.Name,
          batchId: batchId,
        }));

        console.log(payload, "bulk payload ----");
        const response = await resumeBulkMail({ candidates: payload });
        toastSuccess(response?.data?.message);

      } else if (selectedForMail.length === 1) {
        // Single mail
        const single = selectedForMail[0];
        const payload = {
          candidateEmail: single.Email,
          candidateName: single.Name,
          batchId: batchId,
        };

        console.log(payload, "single payload ----");
        const response = await resumeSingleMail(payload);
        toastSuccess(response?.data?.message);
      } else {
        toastError("Please select at least one candidate.");
        return;
      }

      // ✅ Reset after success
      setSelectedCandidates([]);
      setSelectedForMail([]);
      setShowMailModal(false);
      setShowListModal(false);

    } catch (error) {
      console.error(error);
      toastError(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsSending(false);
    }
  };

  const HandleCandiateEdit = async (candidate, id) => {
    console.log(candidate, batchId, id, "hi========")
    const payload = {
      batchId: batchId,
      responseId: id,
      name: candidate.name,
      email: candidate.email,
      mobile: candidate.mobile,
    };

    try {
      const response = await candidateEdit(payload);
      console.log(responseData, "response==")
      toastSuccess(response?.data?.message || "Candidate updated successfully");

      const updatedList = skilldatas?.claudeResponses?.map((item) => {
        return {
          ...item,
          claudeResponse: item.claudeResponse?.map((res) =>
            res.Id === id
              ? {
                ...res,
                Name: candidate.name,
                Email: candidate.email,
                Mobile_No: candidate.mobile,
              }
              : res
          ),
        };
      });

      console.log(updatedList, "updatedList ✅");
      setSkillDatas((prev) => ({ ...prev, claudeResponses: updatedList }))

      setShowEditModal(false);
    } catch (error) {
      console.error("Edit failed:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await resumeUploadList()
        console.log(response, "responseresponse")
        setDummyData(response?.data?.result?.data)
      } catch (error) {
        console.log(error, "rrrrrrrr")
      }
    }
    fetchData()
  }, [])

  const [pdfName, setPdfName] = useState("")

  const handlePdfOpen = (name) => {
    setPdfName(name)
    setShowPDF(true)
  }

  const handlePdfClose = (name) => {
    setPdfName("")
    setShowPDF(false)
  }

  const encodeS3Key = (name = "") =>
  encodeURIComponent(name).replace(/\+/g, '%2B');

  return (
    <div className="p-5">
      <>
        <>
          <div style={{ backgroundColor: "white", padding: "15px" }}>
            <Row className="align-items-center">
              <Col md={7}>
                <h1
                  className="display-4 fw-bold mb-3"
                // style={{ color: "#96144d" }}
                >
                  <span style={{ color: "#96144d" }}>A</span>I{" "}
                  <span style={{ color: "#96144d" }}>I</span>
                  nterview <span style={{ color: "#96144d" }}>S</span>
                  chedule
                </h1>
                <p className="text-muted fs-5 mb-4">
                  The interview will assess your skills in machine learning,
                  coding, and real-time problem-solving. 🤖
                </p>
                <Button
                  variant="primary"
                  style={{ backgroundColor: "#96144d", borderColor: "#96144d" }}
                  className="d-inline-flex align-items-center"
                >
                  Get Start Now <i className="fas fa-arrow-right ms-2"></i>
                </Button>
              </Col>
              <Col md={5} className="text-center">
                <img src={rob} alt="AI Assistant" className="img-fluid" />
              </Col>
            </Row>

            <div className="mb-5">
              <div className="d-flex gap-3 flex-wrap mb-5">

              </div>
              <div className="d-flex flex-wrap gap-4">

              </div>
              <div
                style={{ borderTop: "0.5px solid #ddd", marginTop: "10px" }}
              ></div>
              <div className="mt-4">
                {activeTab === 1 && (
                  <>
                    <Row className="justify-content-end mb-3">
                      <Col xs="auto">
                        {selectedUserIds.length > 0 && (
                          <button
                            style={{
                              padding: "5px 20px",
                              borderRadius: "6px",
                              outline: "none",
                              border: "none",
                              background: "#96144d",
                              color: "white",
                              fontWeight: "600",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                              cursor: "pointer",
                            }}
                            onClick={handleShowModal}
                          >
                            <i class="fa-solid fa-calendar"></i>{" "}
                            <span style={{ paddingLeft: "5px" }}>
                              Interview Slot ( {selectedUserIds?.length} )
                            </span>
                          </button>
                        )}
                      </Col>
                    </Row>

                    <Modal
                      show={isOpen}
                      onHide={clockToggle}
                      centered
                      size="lg"
                    >
                      <ModalBody
                        className="p-4"
                        style={{ background: "white" }}
                      >
                        <h5 className="text-start text-muted mb-4">
                          Schedule Interview Confirmation{" "}
                          <span className="text-primary">
                            ({selectedUserIds.length})
                          </span>
                        </h5>

                        <div className="text-center mb-4">
                          <img
                            src="https://img.freepik.com/free-vector/graident-ai-robot-vectorart_78370-4114.jpg?semt=ais_hybrid&w=740"
                            alt="Confirmation"
                            className="img-fluid"
                            style={{ maxHeight: "250px" }}
                          />
                        </div>

                        <p className="text-center fs-5 text-muted mb-4">
                          Are you sure you want to schedule this interview?
                        </p>

                        <div className="mt-4 mb-3">
                          <div
                            className="d-flex"
                            style={{
                              display: "flex",
                              gap: "20px",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              style={{
                                padding: "6px 40px",
                                border: "none",
                                outline: "none",
                                cursor: "pointer",
                                background: "#96144d",
                                color: "white",
                                borderRadius: "8px",
                              }}
                              onClick={handleScheduleInterview}
                            >
                              Yes
                            </button>
                            <button
                              style={{
                                padding: "6px 40px",
                                border: "1px solid #96144d",
                                outline: "none",
                                cursor: "pointer",
                                background: "white",
                                color: "black",
                                borderRadius: "8px",
                              }}
                              onClick={clockToggle}
                            >
                              No
                            </button>
                          </div>
                        </div>
                      </ModalBody>
                    </Modal>
                    <Container>
                      <h3 className="my-4">Batch List</h3>
                      <Row className="g-4">
                        <Col md={12}>
                          <Table bordered hover responsive>
                            <thead>
                              <tr>
                                <th>JobId</th>
                                <th>Batch Name</th>
                                <th>Report</th>
                                <th>Questions</th>
                                <th>Overall Report</th>
                              </tr>
                            </thead>
                            <tbody>
                              {dummyData?.map((batch) => (
                                <React.Fragment key={batch._id}>
                                  {console.log(batch, "batch========")}
                                  <tr>
                                    <td>{batch.jobId ? batch.jobId : "-"}</td>
                                    <td className="fw-bold text-primary">{batch.batchName}</td>
                                    <td>
                                      <BsEye
                                        size={24}
                                        color="#007bff"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleOpenModal(batch)}
                                      />
                                    </td>
                                    <td>
                                      <BsEye
                                        size={24}
                                        color="#007bff"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleOpenQuesModal(batch)}
                                      />
                                    </td>
                                    <td>
                                      <BsEye
                                        size={24}
                                        color="#007bff"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleOpenListModal(batch)}
                                      />
                                    </td>
                                  </tr>

                                  <Modal show={showModal} onHide={handleCloseModal} size="xl">
                                    {console.log(skilldatas, "selectedBatch=======")}

                                    <Modal.Header closeButton>
                                      <Modal.Title>
                                        {selectedBatch?.batchName} - Candidates
                                      </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>

                                      <div className="table-responsive">
                                        <div className="d-flex justify-content-end mb-3">
                                          <Button
                                            className="me-2 d-flex align-items-center"
                                            variant="outline-primary"
                                            onClick={handleRefresh}
                                            disabled={isRefreshing}
                                            style={{
                                              padding: "8px 16px",
                                              borderRadius: "8px",
                                              fontWeight: "500",
                                              transition: "all 0.2s ease",
                                              border: "2px solid #007bff",
                                              backgroundColor: isRefreshing ? "#f8f9fa" : "transparent",
                                              opacity: isRefreshing ? 0.7 : 1
                                            }}
                                            onMouseEnter={(e) => {
                                              if (!isRefreshing) {
                                                e.target.style.backgroundColor = "#007bff";
                                                e.target.style.color = "white";
                                                e.target.style.transform = "translateY(-1px)";
                                                e.target.style.boxShadow = "0 4px 8px rgba(0,123,255,0.3)";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (!isRefreshing) {
                                                e.target.style.backgroundColor = "transparent";
                                                e.target.style.color = "#007bff";
                                                e.target.style.transform = "translateY(0)";
                                                e.target.style.boxShadow = "none";
                                              }
                                            }}
                                          >
                                            {isRefreshing ? (
                                              <>
                                                <div
                                                  className="spinner-border spinner-border-sm me-2"
                                                  role="status"
                                                  style={{ width: "14px", height: "14px" }}
                                                >
                                                  <span className="visually-hidden">Loading...</span>
                                                </div>
                                                Refreshing...
                                              </>
                                            ) : (
                                              <>
                                                <i className="fas fa-sync-alt me-2" style={{ fontSize: "14px" }}></i>
                                                Refresh
                                              </>
                                            )}
                                          </Button>
                                          <Button
                                            className="d-flex align-items-center"
                                            variant="primary"
                                            onClick={handleMailSend}
                                            disabled={isRefreshing || isSendings} // disable when refreshing or sending
                                            style={{
                                              padding: "8px 16px",
                                              borderRadius: "8px",
                                              fontWeight: "500",
                                              opacity: isRefreshing || isSendings ? 0.7 : 1
                                            }}
                                          >
                                            {isSendings ? (
                                              <>
                                                <span
                                                  className="spinner-border spinner-border-sm me-2"
                                                  role="status"
                                                  aria-hidden="true"
                                                ></span>
                                                Sending...
                                              </>
                                            ) : (
                                              <>
                                                <i className="fas fa-paper-plane me-2" style={{ fontSize: "14px" }}></i>
                                                Send AI Interview
                                              </>
                                            )}
                                          </Button>
                                        </div>

                                        {/* Loading overlay for table */}
                                        <div style={{ position: 'relative' }}>
                                          {isRefreshing && (
                                            <div
                                              style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                zIndex: 10,
                                                borderRadius: '8px'
                                              }}
                                            >
                                              <div className="text-center">
                                                <div className="spinner-border text-primary mb-2" role="status">
                                                  <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <div style={{ color: '#007bff', fontWeight: '500' }}>Loading data...</div>
                                              </div>
                                            </div>
                                          )}

                                          <Table bordered hover style={{ opacity: isRefreshing ? 0.6 : 1 }}>
                                            <thead>
                                              <tr style={{ fontSize: "14px" }}>
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Resume Match</th>
                                                <th>CI</th>
                                                <th>Report</th>
                                                <th>Status</th>
                                                <th>Interview Report</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {[...(skilldatas?.claudeResponses || [])]
                                                .flatMap((item) =>
                                                  (item?.claudeResponse || []).map((res) => ({
                                                    ...res,
                                                    parentItem: item,
                                                  }))
                                                )
                                                .sort(
                                                  (a, b) =>
                                                    parseFloat(b.Overall_Score.replace('%', '')) -
                                                    parseFloat(a.Overall_Score.replace('%', ''))
                                                )
                                                .map((items, index) => (
                                                  <tr key={items.Id}>
                                                    {console.log(items, "ioii")}
                                                    <td>{index + 1}</td>
                                                    <td>{items.Name}</td>
                                                    <td>{items.Email}</td>
                                                    <td
                                                      style={{
                                                        color:
                                                          getMatchBadgeColor(parseFloat(items.Overall_Score.replace('%', ''))) === "success"
                                                            ? "#57c67d"
                                                            : getMatchBadgeColor(parseFloat(items.Overall_Score.replace('%', ''))) === "warning"
                                                              ? "#f2af51"
                                                              : getMatchBadgeColor(parseFloat(items.Overall_Score.replace('%', ''))) === "info"
                                                                ? "#3498db"
                                                                : "red",
                                                        fontWeight: "600",
                                                      }}
                                                    >
                                                      {items.Overall_Score}
                                                    </td>
                                                    <td>
                                                      {items.parentItem.emailStatus?.toLowerCase() === "yes" ? (
                                                        <i className="fa-solid fa-circle-check" style={{ color: "green", fontSize: "18px" }}></i>
                                                      ) : items.parentItem.emailStatus === "" || items.parentItem.emailStatus == null || items.parentItem.emailStatus == "sent" ? (
                                                        "-"
                                                      ) : (
                                                        <i className="fa-solid fa-circle-xmark" style={{ color: "red", fontSize: "18px" }}></i>
                                                      )}
                                                    </td>
                                                    <td>
                                                      <BsEye
                                                        size={24}
                                                        color="#007bff"
                                                        style={{ cursor: isRefreshing ? "not-allowed" : "pointer", opacity: isRefreshing ? 0.5 : 1 }}
                                                        onClick={() => !isRefreshing && handleOpenModals(items)}
                                                      />
                                                    </td>
                                                    <td>{items.parentItem?.status}</td>
                                                    {console.log(items.parentItem, "cdcdcdcdcd")}
                                                    <td>
                                                      {items.parentItem?.cronStatus === true ? (
                                                        <BsEye
                                                          size={24}
                                                          color="#007bff"
                                                          style={{
                                                            cursor: isRefreshing ? "not-allowed" : "pointer",
                                                            opacity: isRefreshing ? 0.5 : 1
                                                          }}
                                                          onClick={() => !isRefreshing && handleOpenModals1(items.parentItem)}
                                                        />
                                                      ) : items.parentItem?.status === "Ended" && items.parentItem?.cronStatus === false ? (
                                                        <p>Processing</p>
                                                      ) : (
                                                        "-"
                                                      )}
                                                    </td>
                                                  </tr>
                                                ))}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </Modal.Body>
                                  </Modal>
                                </React.Fragment>
                              ))}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>

                      <Modal show={showListModal} onHide={handleListCloseModal} size="xl">
                        <Modal.Header closeButton>
                          <Modal.Title>
                            {selectedBatch?.batchName} - Candidates
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="table-responsive">
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="form-check d-flex align-items-center mb-2">
                                {skilldatas?.claudeResponses?.some(item => item.emailStatus == null) && (
                                  <div className="form-check d-flex align-items-center mb-2">
                                    {console.log(skilldatas, selectedCandidates, "selectedCandidates--")}
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={
                                        (() => {
                                          // ✅ Collect unique parentItem._id for emailStatus null
                                          const nullEmailStatusCandidateIds = skilldatas?.claudeResponses
                                            ?.filter(item => item.emailStatus == null)
                                            .map(item => item._id);

                                          return (
                                            nullEmailStatusCandidateIds.length > 0 &&
                                            nullEmailStatusCandidateIds.every(id => selectedCandidates.includes(id))
                                          );
                                        })()
                                      }
                                      onChange={(e) => {
                                        const nullEmailStatusCandidateIds = skilldatas?.claudeResponses
                                          ?.filter(item => item.emailStatus == null)
                                          .map(item => item._id);

                                        if (e.target.checked) {
                                          setSelectedCandidates(prev => [
                                            ...new Set([...prev, ...nullEmailStatusCandidateIds]), // ✅ Add all unique _id
                                          ]);
                                        } else {
                                          setSelectedCandidates(prev =>
                                            prev.filter(id => !nullEmailStatusCandidateIds.includes(id)) // ✅ Remove only those
                                          );
                                        }
                                      }}
                                      style={{
                                        width: '1.3em',
                                        height: '1.3em',
                                        borderRadius: '4px',
                                        boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
                                        border: '1px solid #000',
                                        marginRight: '10px'
                                      }}
                                    />

                                    <label className="form-check-label mb-0">Select All</label>
                                  </div>
                                )}
                              </div>
                              {console.log(selectedCandidates, "selectedCandidates")}
                              <div className="d-flex justify-content-end mb-3">
                                {selectedCandidates.length > 0 && (
                                  <Button
                                    style={{ backgroundColor: "#97144d", border: "none" }}
                                    className="mb-2"
                                    onClick={handleSendMail}
                                  >
                                    <FaEnvelope className="me-2" size={16} />
                                    Send Mail to Selected ({selectedCandidates.length})
                                  </Button>
                                )}
                                <Modal show={showMailModal} onHide={handleCloseMailModal}>
                                  <Modal.Header closeButton>
                                    <Modal.Title>Send Mail</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    {console.log(selectedForMail, "selectedForMail==")}
                                    {selectedForMail.length > 0 ? (
                                      <ul>
                                        {selectedForMail.map((candidate) => (
                                          <li key={candidate.Id}>{candidate.Name}</li>
                                        ))}
                                      </ul>
                                    ) : (
                                      <p>No candidates selected.</p>
                                    )}
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseListModal}>
                                      Cancel
                                    </Button>
                                    <Button variant="primary" onClick={selectedMailSend} disabled={isSending}>
                                      {isSending ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                          Sending...
                                        </>
                                      ) : (
                                        "Confirm Send"
                                      )}
                                    </Button>
                                  </Modal.Footer>
                                </Modal>
                              </div>
                            </div>
                            <Row className="align-items-center mb-3">
                              {console.log(skilldatas, "skilldatas==skilldatas")}
                              {[...(skilldatas?.claudeResponses || [])]
                                .flatMap((item) =>
                                  (item?.claudeResponse || []).map((res) => ({
                                    ...res,
                                    parentItem: item,
                                  }))
                                )
                                .sort(
                                  (a, b) =>
                                    parseFloat(b.Overall_Score.replace('%', '')) -
                                    parseFloat(a.Overall_Score.replace('%', ''))
                                )
                                .map((items, index) => {
                                  const isExpanded = expandedCard === items?.parentItem?._id;
                                  const isSelected = selectedCandidates.includes(items.Id);

                                  return (
                                    <Card className="mb-4 shadow-sm" key={items?.parentItem?._id}>
                                      <Card.Body>
                                        {console.log(items, "eeeeeee")}
                                        <Row className="align-items-center">
                                          <Col md={1} className="text-center">
                                            {items?.parentItem?.emailStatus === null ? (
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={selectedCandidates.includes(items?.parentItem?._id)}  // ✅ use parentItem._id
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    setSelectedCandidates((prev) => [...prev, items?.parentItem?._id]);
                                                  } else {
                                                    setSelectedCandidates((prev) =>
                                                      prev.filter((id) => id !== items?.parentItem?._id)
                                                    );
                                                  }
                                                }}
                                                style={{
                                                  width: '1.3em',
                                                  height: '1.3em',
                                                  borderRadius: '4px',
                                                  boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
                                                  border: '1px solid #000',
                                                  marginLeft: '10px',
                                                }}
                                              />
                                            ) : null}
                                          </Col>

                                          <Col md={4}>
                                            <div className="d-flex align-items-start">
                                              <div>
                                                <h5>{items?.Name}</h5>
                                                <div className="small text-muted">
                                                  <Mail size={14} className="me-1" /> {items?.Email}
                                                </div>
                                                <div className="small text-muted">
                                                  <Phone size={14} className="me-1" /> {items?.Mobile_No}
                                                </div>
                                              </div>
                                              <Button variant="link" className="p-0 ms-2"
                                                onClick={() => {
                                                  setEditCandidate({
                                                    id: items?.Id, // ✅ Add id here
                                                    name: items?.Name,
                                                    email: items?.Email,
                                                    mobile: items?.Mobile_No,
                                                  });
                                                  setShowEditModal(true);
                                                }}>
                                                <FaEdit size={18} />
                                              </Button>
                                              <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                                                <Modal.Header closeButton>
                                                  <Modal.Title>Edit Candidate</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                  <Form>
                                                    <Form.Group className="mb-3">
                                                      <Form.Label>Name</Form.Label>
                                                      <Form.Control
                                                        type="text"
                                                        value={editCandidate.name}
                                                        onChange={(e) =>
                                                          setEditCandidate({ ...editCandidate, name: e.target.value })
                                                        }
                                                      />
                                                    </Form.Group>
                                                    <Form.Group className="mb-3">
                                                      <Form.Label>Email</Form.Label>
                                                      <Form.Control
                                                        type="email"
                                                        value={editCandidate.email}
                                                        onChange={(e) =>
                                                          setEditCandidate({ ...editCandidate, email: e.target.value })
                                                        }
                                                      />
                                                    </Form.Group>
                                                    <Form.Group className="mb-3">
                                                      <Form.Label>Mobile</Form.Label>
                                                      <Form.Control
                                                        type="text"
                                                        value={editCandidate.mobile}
                                                        onChange={(e) =>
                                                          setEditCandidate({ ...editCandidate, mobile: e.target.value })
                                                        }
                                                      />
                                                    </Form.Group>
                                                  </Form>
                                                </Modal.Body>
                                                <Modal.Footer>
                                                  <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                                                    Cancel
                                                  </Button>
                                                  <Button
                                                    variant="primary"
                                                    onClick={() => {
                                                      HandleCandiateEdit(editCandidate, editCandidate.id); // ✅ Use the id from state
                                                    }}
                                                  >
                                                    Save Changes
                                                  </Button>
                                                </Modal.Footer>
                                              </Modal>
                                            </div>
                                          </Col>

                                          <Col md={2} className="text-center">
                                            <h4>{items?.Overall_Score}</h4>
                                            <div className="small text-muted">Match Score</div>
                                          </Col>

                                          <Col md={2}>
                                            {/* You can show badge/status here */}
                                            {items?.parentItem?.emailStatus === "yes" && <>✅</>}
                                            {items?.parentItem?.emailStatus === "no" && <>❌</>}
                                            {items?.parentItem?.emailStatus === "sent" && <p style={{ color: "blue" }}>Sent</p>}
                                          </Col>

                                          <Col md={3} className="text-end">
                                            <Button
                                              className="mt-1 fw-bold"
                                              onClick={() => toggleCardExpansion(items?.parentItem?._id)}
                                              style={{ color: "#97144d", border: "none", backgroundColor: "#fff" }}
                                            >
                                              {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />} Details
                                            </Button>
                                          </Col>
                                        </Row>

                                        {isExpanded && (
                                          <div className="mt-4 px-2">
                                            <Row>
                                              <Col md={6}>
                                                <h6 className="text-success">Matching Skills</h6>
                                                <div className="d-flex flex-wrap gap-2">
                                                  {items?.Matched_Skills?.length > 0 ? (
                                                    items.Matched_Skills.map((skill, i) => (
                                                      <Badge bg="success" key={i}>{skill}</Badge>
                                                    ))
                                                  ) : (
                                                    <p className="text-muted">No matching skills</p>
                                                  )}
                                                </div>
                                              </Col>

                                              <Col md={6}>
                                                <h6 className="text-danger">Missing Skills</h6>
                                                <div className="d-flex flex-wrap gap-2">
                                                  {items?.Missing_Skills?.length > 0 ? (
                                                    items.Missing_Skills.map((skill, i) => (
                                                      <Badge bg="danger" key={i}>{skill}</Badge>
                                                    ))
                                                  ) : (
                                                    <p className="text-muted">No missing skills</p>
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>

                                            <Row className="mt-3">
                                              <Col md={6}>
                                                <p><strong>Recommendation:</strong> {items.Recommendation}</p>
                                                <p><strong>Match Level:</strong> {items.Match_Level}</p>
                                              </Col>
                                              {console.log(items, "itemsitems")}
                                              <Col md={6}>
                                                <p>
                                                  <strong>Resume:</strong>{' '}
                                                  <span
                                                    style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                                                    // onClick={() => setShowPDF(true)}
                                                    onClick={() => handlePdfOpen(items.File_Name)}
                                                  >
                                                    {items.File_Name}
                                                  </span>
                                                </p>

                                                <Modal
                                                  show={showPDF}
                                                  onHide={handlePdfClose}
                                                  size="xl"
                                                  centered
                                                  scrollable
                                                >
                                                  {console.log(items, "items--")}
                                                  <Modal.Header closeButton>
                                                    <Modal.Title>PDF Viewer - {pdfName}</Modal.Title>
                                                  </Modal.Header>
                                                  <Modal.Body>
                                                    <ResumeViewer fileUrl={`https://cdp-job-portal-v2.s3.ap-south-1.amazonaws.com/PROD/ai_resume/${encodeS3Key(items?.File_Name)}`} />                                                  </Modal.Body>
                                                </Modal>
                                              </Col>
                                            </Row>

                                            <Row className="mt-3">
                                              <Col>
                                                <p><strong>Justification:</strong></p>
                                                <p>{items.Justification}</p>

                                                {items?.Positive_Aspects?.length > 0 && (
                                                  <>
                                                    <p className="text-success"><strong>Positive:</strong></p>
                                                    <ul>
                                                      {items.Positive_Aspects.map((pos, i) => (
                                                        <li key={i}>{pos}</li>
                                                      ))}
                                                    </ul>
                                                  </>
                                                )}

                                                {items?.Negative_Aspects?.length > 0 && (
                                                  <>
                                                    <p className="text-danger"><strong>Negative:</strong></p>
                                                    <ul>
                                                      {items.Negative_Aspects.map((neg, i) => (
                                                        <li key={i}>{neg}</li>
                                                      ))}
                                                    </ul>
                                                  </>
                                                )}
                                              </Col>
                                            </Row>
                                          </div>
                                        )}
                                      </Card.Body>
                                    </Card>
                                  );
                                })}
                            </Row>
                          </div>
                        </Modal.Body>
                      </Modal>

                      <Modal show={showQuesModal} onHide={handleQuesCloseModal} size="xl" centered scrollable>
                        <Modal.Header closeButton>
                          <Modal.Title>{questionData?.batchName} - Questions Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div>
                            {/* Bootstrap CDN + Custom Styles */}
                            <link
                              href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
                              rel="stylesheet"
                            />
                            <link
                              href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.10.0/font/bootstrap-icons.min.css"
                              rel="stylesheet"
                            />
                            <style jsx>{`
        body {
          background: #97144D;
          min-height: 100vh;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        .gradient-card {
          background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
          border: none;
          border-radius: 20px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          backdrop-filter: blur(10px);
        }
        .gradient-header {
          background: #97144D;
          border-radius: 20px 20px 0 0 !important;
        }
        .question-card {
          background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
          border: 1px solid rgba(255,255,255,0.2);
          border-radius: 15px;
          box-shadow: 0 8px 32px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
        }
        .question-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 45px rgba(0,0,0,0.15);
        }
        .btn-glass {
          background: rgba(255, 255, 255, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(10px);
          color: white;
          border-radius: 12px;
          transition: all 0.3s ease;
        }
        .btn-glass:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: translateY(-2px);
          color: white;
        }
        .btn-modern {
          border-radius: 12px;
          padding: 8px 16px;
          font-weight: 500;
          transition: all 0.3s ease;
          border: none;
        }
        .btn-modern:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.2);
        }
        .form-control-modern {
          border-radius: 12px;
          border: 2px solid #e9ecef;
          padding: 12px 16px;
          transition: all 0.3s ease;
          background: rgba(255, 255, 255, 0.9);
        }
        .form-control-modern:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
          transform: translateY(-1px);
        }
        .badge-modern {
          border-radius: 20px;
          padding: 8px 12px;
          font-weight: 600;
          background: #97144D;
        }
        .alert-modern {
          border-radius: 15px;
          border: none;
          box-shadow: 0 8px 25px rgba(0,0,0,0.1);
        }
        .edit-section {
          background: linear-gradient(145deg, #fff3cd 0%, #ffeaa7 100%);
          border-radius: 15px;
          border: 2px solid rgba(255, 193, 7, 0.3);
        }
        .add-section {
          background: linear-gradient(145deg, #d1ecf1 0%, #bee5eb 100%);
          border: 2px solid rgba(23, 162, 184, 0.3);
        }
        .empty-state {
          background: linear-gradient(145deg, #f8f9fa 0%, #e9ecef 100%);
          border-radius: 20px;
          padding: 3rem;
          border: 2px dashed #dee2e6;
        }
        .question-number {
          background: #97144D;
          color: white;
          width: 35px;
          height: 35px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          margin-right: 15px;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }
        .icon-bounce {
          animation: bounce 2s infinite;
        }
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-10px); }
          60% { transform: translateY(-5px); }
        }
      `}</style>

                            <div className="container py-5">
                              <div className="row justify-content-center">
                                <div className="col-lg-12">
                                  <div className="card gradient-card shadow-lg">
                                    <div className="card-header gradient-header text-white py-4">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <h3 className="mb-0 fw-bold">
                                          <i className="bi bi-lightbulb-fill me-3"></i>
                                          Question Manager
                                        </h3>
                                        <button
                                          className="btn btn-glass btn-modern"
                                          onClick={() => setShowAddForm(prev => !prev)}
                                        >
                                          <i className={`bi ${showAddForm ? 'bi-x-circle' : 'bi-plus-circle'} me-2`}></i>
                                          {showAddForm ? "Close" : "Add Question"}
                                        </button>
                                      </div>
                                    </div>

                                    <div className="card-body p-4">
                                      {/* Add Form */}
                                      {showAddForm && (
                                        <div className="alert alert-modern add-section mb-4">
                                          <h5 className="text-info fw-bold mb-3">
                                            <i className="bi bi-plus-square-fill me-2"></i>
                                            Create New Question
                                          </h5>
                                          <div className="row g-3">
                                            <div className="col-md-8">
                                              <input
                                                type="text"
                                                className="form-control form-control-modern"
                                                value={newQuestion}
                                                placeholder="What would you like to ask?"
                                                onChange={(e) => setNewQuestion(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && handleAddQuestion()}
                                              />
                                            </div>
                                            <div className="col-md-4">
                                              <div className="d-flex gap-2">
                                                <button
                                                  className="btn btn-success btn-modern flex-fill"
                                                  onClick={handleAddQuestion}
                                                  disabled={!newQuestion.trim()}
                                                >
                                                  <i className="bi bi-check-circle-fill me-1"></i>
                                                  Add
                                                </button>
                                                <button
                                                  className="btn btn-outline-secondary btn-modern flex-fill"
                                                  onClick={() => {
                                                    setNewQuestion("");
                                                    setShowAddForm(false);
                                                  }}
                                                >
                                                  <i className="bi bi-x-circle me-1"></i>
                                                  Cancel
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {/* Questions List */}
                                      {questionData?.questionsResponse?.length === 0 ? (
                                        <div className="empty-state text-center">
                                          <i className="bi bi-inbox fs-1 text-muted icon-bounce"></i>
                                          <h4 className="mt-3 text-muted">No Questions Yet</h4>
                                          <p className="text-muted fs-5">Start building your question list by clicking "Add Question" above!</p>
                                        </div>
                                      ) : (
                                        <div className="row g-4">
                                          {questionData?.questionsResponse?.map((question, index) => (
                                            <div key={index} className="col-12">
                                              <div className="question-card p-4">
                                                <div className="d-flex align-items-start">
                                                  <div className="question-number">{index + 1}</div>
                                                  <div className="flex-grow-1">
                                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                                      <div>
                                                        <span className="badge badge-modern me-2">Question {index + 1}</span>
                                                      </div>
                                                      <div className="btn-group">
                                                        <button
                                                          className="btn btn-outline-primary btn-modern btn-sm"
                                                          onClick={() => handleEdit(index, question)}
                                                          disabled={editingId === index}
                                                          title="Edit Question"
                                                        >
                                                          <i className="bi bi-pencil-square"></i>
                                                        </button>
                                                        {console.log(question, "delete")}
                                                        <button
                                                          className="btn btn-outline-danger btn-modern btn-sm"
                                                          onClick={() => handleDelete(index, questionData._id)}
                                                          title="Delete Question"
                                                        >
                                                          <i className="bi bi-trash3"></i>
                                                        </button>
                                                      </div>
                                                    </div>

                                                    <p className="fs-5 mb-0 text-dark fw-medium">{question}</p>

                                                    {editingId === index && (
                                                      <div className="edit-section alert-modern mt-4 p-4">
                                                        <h6 className="text-warning fw-bold mb-3">
                                                          <i className="bi bi-pencil-square me-2"></i>
                                                          Edit Question
                                                        </h6>
                                                        <textarea
                                                          className="form-control form-control-modern mb-3"
                                                          value={editText}
                                                          onChange={(e) => setEditText(e.target.value)}
                                                          rows={3}
                                                          placeholder="Update your question..."
                                                        />
                                                        <div className="d-flex gap-2">
                                                          <button
                                                            className="btn btn-success btn-modern"
                                                            onClick={() => handleSave(index)}
                                                            disabled={!editText.trim()}
                                                          >
                                                            <i className="bi bi-check-circle-fill me-2"></i>
                                                            Save Changes
                                                          </button>
                                                          <button
                                                            className="btn btn-outline-secondary btn-modern"
                                                            onClick={cancelEdit}
                                                          >
                                                            <i className="bi bi-x-circle me-2"></i>
                                                            Cancel
                                                          </button>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ))}

                                        </div>
                                      )}
                                    </div>

                                    <div className="card-footer text-center py-3" style={{ background: 'linear-gradient(145deg, #f8f9fa 0%, #e9ecef 100%)', borderRadius: '0 0 20px 20px' }}>
                                      <div className="d-flex justify-content-center align-items-center">
                                        <i className="bi bi-info-circle-fill text-primary me-2"></i>
                                        <span className="fw-bold text-primary">Total Questions: {questionData?.questionsResponse?.length}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                      </Modal>

                      <Modal show={showModal1} onHide={handleCloseModals} size="xl" centered scrollable>
                        <Modal.Header closeButton>
                          <Modal.Title>Candidate Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {candidate && (
                            <>
                              <Row className="mb-3">
                                <Col md={6}>
                                  <h6 className="text-success">Matching Skills</h6>
                                  <div className="d-flex flex-wrap gap-2">
                                    {candidate.Matched_Skills?.map((skill) => (
                                      <Badge bg="success" key={skill}>{skill}</Badge>
                                    ))}
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <h6 className="text-danger">Missing Skills</h6>
                                  <div className="d-flex flex-wrap gap-2">
                                    {candidate.Missing_Skills?.map((skill) => (
                                      <Badge bg="danger" key={skill}>{skill}</Badge>
                                    ))}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <p><strong>Recommendation:</strong> <span className={`text-${candidate.color}`}>{candidate.Recommendation}</span></p>
                                  <p><strong>Match Level:</strong> {candidate.Match_Level}</p>
                                </Col>
                                <Col md={6}>
                                  <>
                                    <p>
                                      <strong>Resume:</strong>{' '}
                                      <span
                                        style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={() => setShowPDF(true)}
                                      >
                                        {candidate.File_Name}
                                      </span>
                                    </p>

                                    <Modal
                                      show={showPDF}
                                      onHide={() => setShowPDF(false)}
                                      size="xl"
                                      centered
                                      scrollable
                                    >
                                      <Modal.Header closeButton>
                                        <Modal.Title>PDF Viewer - {candidate.File_Name}</Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        <ResumeViewer fileUrl={`https://cdp-job-portal-v2.s3.ap-south-1.amazonaws.com/PROD/ai_resume/${encodeS3Key(candidate.File_Name)}`} />
                                      </Modal.Body>
                                    </Modal>
                                  </>
                                </Col>
                                {/* <Col md={6}>
                                  <p><strong>Experience:</strong> {candidate.experience}</p>
                                  <p><strong>Location:</strong> {candidate.location}</p>
                                  <p><strong>Resume:</strong> {candidate.fileName}</p>
                                </Col> */}
                              </Row>

                              <Row>
                                <Col>
                                  <p><strong>Justification:</strong></p>
                                  <p>{candidate.Justification}</p>

                                  {candidate?.Positive_Aspects?.length > 0 && (
                                    <>
                                      <p className="text-success"><strong>Positive:</strong></p>
                                      <ul>
                                        {candidate.Positive_Aspects.map((pos, i) => (
                                          <li key={i}>{pos}</li>
                                        ))}
                                      </ul>
                                    </>
                                  )}

                                  {candidate?.Negative_Aspects?.length > 0 && (
                                    <>
                                      <p className="text-danger"><strong>Negative:</strong></p>
                                      <ul>
                                        {candidate.Negative_Aspects.map((neg, i) => (
                                          <li key={i}>{neg}</li>
                                        ))}
                                      </ul>
                                    </>
                                  )}
                                </Col>
                              </Row>
                            </>
                          )}
                        </Modal.Body>
                      </Modal>

                      <Modal show={showModal2} onHide={handleCloseModals1} size="xl" centered scrollable>
                        <Modal.Header closeButton>
                          <Modal.Title>
                            Feedback on the Interview
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <FeedBack feedBackdata={feedBack} />
                        </Modal.Body>
                      </Modal>
                    </Container>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        cursor: "pointer",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    >
                    </div>
                  </>
                )}
                {activeTab === 2 && (
                  <>
                    <div className="p-3 table-responsive">
                      <table responsive>
                        <thead>
                          <tr style={{ fontSize: "16px" }}>

                            <th>S.No</th>
                            <th>Candidate Id</th>
                            <th>Job Id</th>
                            <th>UserName</th>
                            <th>Resume's Matched</th>
                            <th>
                              CI- Y{" "}
                              <span>
                                {" "}
                                <i
                                  class="fa-solid fa-circle-check"
                                  style={{
                                    color: "green",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                  }}
                                ></i>
                              </span>
                              / N{" "}
                              <span>
                                {" "}
                                <i
                                  class="fa-solid fa-circle-xmark"
                                  style={{
                                    color: "red",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                  }}
                                ></i>
                              </span>
                            </th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {skilldatas
                            .map((item, index) => (
                              <tr key={index}>

                                <td>{index + 1}</td>
                                <td style={{ fontSize: "14px" }}>
                                  {item?.candidateId}
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  {item?.jobId}
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  {item?.userName}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    color:
                                      getMatchBadgeColor(item?.percentage) ==
                                        "success"
                                        ? "#57c67d"
                                        : getMatchBadgeColor(
                                          item?.percentage
                                        ) == "warning"
                                          ? "#f2af51"
                                          : "grey",
                                    fontWeight: "600",
                                  }}
                                >
                                  {item?.percentage}%
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  <span>
                                    {item?.status == "Yes" ? (
                                      <>
                                        <i
                                          class="fa-solid fa-circle-check"
                                          style={{
                                            color: "green",
                                            fontWeight: "600",
                                            fontSize: "18px",
                                          }}
                                        ></i>
                                      </>
                                    ) : (
                                      <>
                                        {item?.status == "" ? (
                                          <>-</>
                                        ) : (
                                          <>
                                            <i
                                              class="fa-solid fa-circle-xmark"
                                              style={{
                                                color: "red",
                                                fontWeight: "600",
                                                fontSize: "18px",
                                              }}
                                            ></i>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </span>
                                </td>
                                <td
                                  style={{
                                    fontSize: "11px",

                                    background:
                                      item?.userStatus == "Completed"
                                        ? "#00c875"
                                        : item?.userStatus == "Pending"
                                          ? "#579bfc"
                                          : "#e55e72",
                                    color: "white",
                                    fontWeight: "600",
                                  }}
                                >
                                  {item?.userStatus}
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  <div className="d-grid gap-3">
                                    {item?.status == "Yes" ? (
                                      <>
                                        <button
                                          size="sm"
                                          outline
                                          className="d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "100%",
                                            background: "#96144d",
                                            border: "none",
                                            color: "white",
                                            borderRadius: "4px",
                                          }}
                                          onClick={() =>
                                            handleNavigatePath(item?.id)
                                          }
                                        >
                                          <Eye size={14} className="me-1" />
                                          {/* <span style={{ paddingLeft: '4px' }}>
                                    View Details
                                  </span> */}
                                        </button>
                                      </>
                                    ) : (
                                      <>-</>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                {activeTab === 3 && (
                  <>
                    <div className="p-3 table-responsive">
                      <table responsive>
                        <thead>
                          <tr style={{ fontSize: "16px" }}>

                            <th>S.No</th>
                            <th>Candidate Id</th>
                            <th>Job Id</th>
                            <th>UserName</th>
                            <th>Resume's Matched</th>
                            <th>
                              CI- Y{" "}
                              <span>
                                {" "}
                                <i
                                  class="fa-solid fa-circle-check"
                                  style={{
                                    color: "green",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                  }}
                                ></i>
                              </span>
                              / N{" "}
                              <span>
                                {" "}
                                <i
                                  class="fa-solid fa-circle-xmark"
                                  style={{
                                    color: "red",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                  }}
                                ></i>
                              </span>
                            </th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {skilldatas
                            ?.filter(
                              (item) => item?.userStatus === "Not Completed"
                            )
                            ?.slice(
                              currentPage === 1
                                ? 0
                                : Number(currentPage - 1) * Number(10),
                              currentshowsecond
                            )
                            .map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td style={{ fontSize: "14px" }}>
                                  {item?.candidateId}
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  {item?.jobId}
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  {item?.userName}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    color:
                                      getMatchBadgeColor(item?.percentage) ==
                                        "success"
                                        ? "#57c67d"
                                        : getMatchBadgeColor(
                                          item?.percentage
                                        ) == "warning"
                                          ? "#f2af51"
                                          : "grey",
                                    fontWeight: "600",
                                  }}
                                >
                                  {item?.percentage}%
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  <span>
                                    {item?.status == "Yes" ? (
                                      <>
                                        <i
                                          class="fa-solid fa-circle-check"
                                          style={{
                                            color: "green",
                                            fontWeight: "600",
                                            fontSize: "18px",
                                          }}
                                        ></i>
                                      </>
                                    ) : (
                                      <>
                                        {item?.status == "" ? (
                                          <>-</>
                                        ) : (
                                          <>
                                            <i
                                              class="fa-solid fa-circle-xmark"
                                              style={{
                                                color: "red",
                                                fontWeight: "600",
                                                fontSize: "18px",
                                              }}
                                            ></i>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </span>
                                </td>
                                <td
                                  style={{
                                    fontSize: "11px",

                                    background:
                                      item?.userStatus == "Completed"
                                        ? "#00c875"
                                        : item?.userStatus == "Pending"
                                          ? "#579bfc"
                                          : "#e55e72",
                                    color: "white",
                                    fontWeight: "600",
                                  }}
                                >
                                  {item?.userStatus}
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  <div className="d-grid gap-3">
                                    {item?.status == "Yes" ? (
                                      <>
                                        <Button
                                          color="success"
                                          size="sm"
                                          outline
                                          className="d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "100%",
                                          }}
                                          onClick={() =>
                                            handleNavigatePath(item?.id)
                                          }
                                        >
                                          <Eye size={14} className="me-1" />
                                        </Button>
                                      </>
                                    ) : (
                                      <>-</>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {activeTab === 4 && (
                  <>
                    <div className="p-3 table-responsive">
                      <table responsive>
                        <thead>
                          <tr style={{ fontSize: "16px" }}>

                            <th>S.No</th>
                            <th>Candidate Id</th>
                            <th>Job Id</th>
                            <th>UserName</th>
                            <th>Resume's Matched</th>
                            <th>
                              CI- Y{" "}
                              <span>
                                {" "}
                                <i
                                  class="fa-solid fa-circle-check"
                                  style={{
                                    color: "green",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                  }}
                                ></i>
                              </span>
                              / N{" "}
                              <span>
                                {" "}
                                <i
                                  class="fa-solid fa-circle-xmark"
                                  style={{
                                    color: "red",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                  }}
                                ></i>
                              </span>
                            </th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {skilldatas
                            .map((item, index) => (
                              <tr key={index}>

                                <td>{index + 1}</td>
                                <td style={{ fontSize: "14px" }}>
                                  {item?.candidateId}
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  {item?.jobId}
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  {item?.userName}
                                </td>
                                <td
                                  style={{
                                    fontSize: "14px",
                                    color:
                                      getMatchBadgeColor(item?.percentage) ==
                                        "success"
                                        ? "#57c67d"
                                        : getMatchBadgeColor(
                                          item?.percentage
                                        ) == "warning"
                                          ? "#f2af51"
                                          : "grey",
                                    fontWeight: "600",
                                  }}
                                >
                                  {item?.percentage}%
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  <span>
                                    {item?.status == "Yes" ? (
                                      <>
                                        <i
                                          class="fa-solid fa-circle-check"
                                          style={{
                                            color: "green",
                                            fontWeight: "600",
                                            fontSize: "18px",
                                          }}
                                        ></i>
                                      </>
                                    ) : (
                                      <>
                                        {item?.status == "" ? (
                                          <>-</>
                                        ) : (
                                          <>
                                            <i
                                              class="fa-solid fa-circle-xmark"
                                              style={{
                                                color: "red",
                                                fontWeight: "600",
                                                fontSize: "18px",
                                              }}
                                            ></i>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </span>
                                </td>
                                <td
                                  style={{
                                    fontSize: "11px",

                                    background:
                                      item?.userStatus == "Completed"
                                        ? "#00c875"
                                        : item?.userStatus == "Pending"
                                          ? "#579bfc"
                                          : "#e55e72",
                                    color: "white",
                                    fontWeight: "600",
                                  }}
                                >
                                  {item?.userStatus}
                                </td>
                                <td style={{ fontSize: "14px" }}>
                                  <div className="d-grid gap-3">
                                    {item?.status == "Yes" ? (
                                      <>
                                        <Button
                                          size="sm"
                                          outline
                                          className="d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "100%",
                                            backgroundColor: "#96144d",
                                            color: "white",
                                            outline: "none",
                                            border: "none",
                                          }}
                                          onClick={() =>
                                            handleNavigatePath(item?.id)
                                          }
                                        >
                                          <Eye size={14} className="me-1" />
                                        </Button>
                                      </>
                                    ) : (
                                      <>-</>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>

        <style jsx>{`
          :root {
            --primary: #96144d;
            --secondary: #6c757d;
            --success: #28a745;
            --info: #17a2b8;
            --warning: #ffc107;
            --danger: #dc3545;
            --light: #f8f9fa;
            --dark: #343a40;
            --gray-100: #f8f9fa;
            --gray-200: #e9ecef;
            --gray-300: #dee2e6;
            --gray-800: #343a40;
          }

          .main-content {
            flex: 1;
            padding: 25px;
            overflow-y: auto;
          }

            .card {
           border-radius: 12px;
           border: 1px solid #ddd;
}

.card h5 {
  margin-bottom: 0.5rem;
}

          .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 25px;
          }

          .page-title h1 {
            font-size: 24px;
            font-weight: 600;
          }

          .user-profile {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: var(--primary);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
          }

          .stats-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
            gap: 20px;
            margin-bottom: 25px;
          }

          .stat-card {
            background-color: #fff;
            padding: 20px;
            border-radius: 10px;
            box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
          }

          .stat-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
          }

          .stat-title {
            font-size: 14px;
            color: var(--secondary);
          }

          .stat-icon {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
          }

          .stat-value {
            font-size: 24px;
            font-weight: 700;
          }

          .stat-trend {
            display: flex;
            align-items: center;
            font-size: 12px;
            margin-top: 5px;
          }

          .trend-up {
            color: var(--success);
          }

          .trend-down {
            color: var(--danger);
          }

          .grid-2 {
            display: grid;
            grid-template-columns: 2fr 1fr;
            gap: 20px;
            margin-bottom: 25px;
          }

          .chart-card {
            background-color: #fff;
            padding: 20px;
            border-radius: 10px;
            box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
          }

          .chart-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
          }

          .chart-title {
            font-size: 16px;
            font-weight: 600;
          }

          .chart-options {
            display: flex;
            gap: 10px;
          }

          .chart-option {
            padding: 5px 10px;
            border-radius: 5px;
            font-size: 12px;
            cursor: pointer;
            background-color: var(--gray-200);
          }

          .chart-option.active {
            background-color: var(--primary);
            color: white;
          }

          .chart-area {
            height: 300px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: var(--gray-100);
            border-radius: 8px;
            margin-top: 10px;
          }

          .table-card {
            background-color: #fff;
            padding: 20px;
            border-radius: 10px;
            box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
          }

          .table-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
          }

          .table-title {
            font-size: 16px;
            font-weight: 600;
          }

          .view-all {
            color: var(--primary);
            font-size: 14px;
            cursor: pointer;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th,
          td {
            padding: 12px 15px;
            text-align: left;
            border-bottom: 1px solid var(--gray-300);
          }

          th {
            font-weight: 600;
            color: var(--secondary);
            background-color: var(--gray-100);
          }

          tr:last-child td {
            border-bottom: none;
          }

          .status {
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 12px;
          }

          .status-active {
            background-color: rgba(40, 167, 69, 0.1);
            color: var(--success);
          }

          .status-pending {
            background-color: rgba(255, 193, 7, 0.1);
            color: var(--warning);
          }

          .status-closed {
            background-color: rgba(108, 117, 125, 0.1);
            color: var(--secondary);
          }

          .status-urgent {
            background-color: rgba(220, 53, 69, 0.1);
            color: var(--danger);
          }

          .table-responsive {
            width: 100%;
            overflow-x: auto;
          }

          @media (max-width: 768px) {
            table {
              min-width: 700px; /* or adjust based on your columns */
            }
          }

          /* Make responsive for small screens */
          @media (max-width: 992px) {
            .dashboard {
              flex-direction: column;
            }

            .sidebar {
              width: 100%;
              margin-bottom: 20px;
            }

            .grid-2 {
              grid-template-columns: 1fr;
            }
          }
        `}</style>
      </>
    </div>
  );
};

export default InterviewScheduleScreen;